if (!customElements.get('page-anchor-links')) {
  customElements.define('page-anchor-links', class PageAnchorLinks extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('ul');
      this.scope = document.getElementById('MainContent') || document.querySelector('main');
      if (!this.list || !this.scope) return;

      this.update = () => this.renderLinks();
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.scope, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['id']
      });
      this.renderLinks();
    }

    renderLinks() {
      const currentSection = this.closest('.shopify-section');
      const ids = new Set(Array.from(document.querySelectorAll('[id]'), (target) => target.id));
      const anchors = Array.from(this.scope.querySelectorAll('h2'))
        .filter((heading) => {
          if (!heading.textContent.trim() || heading.closest('page-anchor-links, header, footer')) return false;
          return !currentSection || heading.closest('.shopify-section') !== currentSection;
        })
        .map((heading) => {
          heading.classList.add('page-anchor-target');
          const label = heading.textContent.replace(/\s+/g, ' ').trim();
          if (!heading.id) {
            const slug = label.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
              .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
            const baseId = `page-anchor-${slug}`;
            let id = baseId;
            let suffix = 2;
            while (ids.has(id)) id = `${baseId}-${suffix++}`;
            heading.id = id;
            ids.add(id);
          }
          return { id: heading.id, label };
        });
      const signature = JSON.stringify(anchors);
      if (signature === this.signature) return;
      this.signature = signature;

      this.list.replaceChildren(...anchors.map((target) => {
        const item = document.createElement('li');
        item.className = 'image-content-links__link-item';
        const link = document.createElement('a');
        link.className = 'image-content-links__link';
        link.setAttribute('href', `#${encodeURIComponent(target.id)}`);
        link.textContent = target.label;
        item.appendChild(link);
        return item;
      }));
      this.hidden = anchors.length === 0;
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
